// extracted by mini-css-extract-plugin
var _1 = "kj_5Lu3nOjVVlRpwq5PB";
export { _1 as "group-select" }
